import React from "react";
import { ProductConsumer } from "../../../../Context/AddProWakel";
import RozhanaDataTable from "../IpadRozhanaRaport/RozhanaDataTable";
import RozhanaRowOne from "./RozhanaRowOne";
import Navbar from "../../../../Navbar/Navbar";
const RozhanaHeader = () => {
  return (
    <>
      <ProductConsumer>
        {(value) => {
          const {
            P_error,
            P_ClearError,
            D_jwllakan,
            D_rozhanafroshtn,
            D_rozhanaparawagrtn,
            D_rozhanaGaranawa,
            d_hamw,
            d_froshtn,
            d_parawargrtn,
            d_garanawa
          } = value;
          return (
            <>
              <Navbar />
              <div className="row mt-5">
                {/* Form take moneyy */}
                <div className="col-12 text-warning col-12 ">
                  <div
                    className="card card-warning "
                    style={{ backgroundColor: "#2C3539" }}
                  >
                    <div
                      className="card-header p-1 border-bottom border-warning"
                      style={{ backgroundColor: "#2C3539" }}
                    >
                      <h2 className="card-title tc">ڕاپۆرتی ڕۆژانە</h2>
                    </div>

                    <div className="card-body">
                      <div className="b--black text-right">
                        {P_error != null && (
                          <button
                            className="btn btn-success text-right"
                            type="button"
                          >
                            {P_error.msg ? P_error.msg : P_error.error[0].msg}
                            <span
                              className="ml-2  border-black"
                              onClick={() => P_ClearError()}
                            >
                              X
                            </span>
                          </button>
                        )}
                      </div>
                      <div className="row">
                        <div className="col-sm-3 text-right">
                          <button
                            className="btn btn-warning f4 font-weight-bolder"
                            style={{
                              backgroundColor: `${
                                d_garanawa == true ? "#63120f" : ""
                              }`,
                              color: `${d_garanawa == true ? "white" : ""}`
                            }}
                          >
                            <span
                              className={`font-weight-bold  pointer`}
                              onClick={D_rozhanaGaranawa}
                            >
                              گەڕانەوە بۆ کۆگا
                            </span>
                          </button>
                        </div>
                        <div className="col-sm-3 text-right">
                          <button
                            style={{
                              backgroundColor: `${
                                d_parawargrtn == true ? "#63120f" : ""
                              }`,
                              color: `${d_parawargrtn == true ? "white" : ""}`
                            }}
                            className="btn btn-warning f4 font-weight-bolder"
                          >
                            <span
                              className={`font-weight-bold  pointer`}
                              onClick={D_rozhanaparawagrtn}
                            >
                              پارەوەرگرتن
                            </span>
                          </button>
                        </div>
                        <div className="col-sm-3 text-right f4">
                          <button
                            className="btn btn-warning f4 font-weight-bolder"
                            style={{
                              backgroundColor: `${
                                d_froshtn == true ? "#63120f" : ""
                              }`,
                              color: `${d_froshtn == true ? "white" : ""}`
                            }}
                          >
                            <span
                              className={`font-weight-bold  pointer`}
                              onClick={D_rozhanafroshtn}
                            >
                              فرۆشتن
                            </span>
                          </button>
                        </div>
                        <div className="col-sm-3 text-right">
                          <button
                            style={{
                              backgroundColor: `${
                                d_hamw == true ? "#63120f" : ""
                              }`,
                              color: `${d_hamw == true ? "white" : ""}`
                            }}
                            className="btn btn-warning f4 font-weight-bolder"
                          >
                            <span
                              className={`font-weight-bold  pointer`}
                              onClick={D_jwllakan}
                            >
                              هەموو جووڵەکان
                            </span>
                          </button>
                        </div>
                      </div>
                      <div className="row card-header p-1 mt-2 border-bottom border-warning"></div>

                      <RozhanaDataTable />

                      <RozhanaRowOne />
                    </div>
                  </div>
                </div>
              </div>
            </>
          );
        }}
      </ProductConsumer>
    </>
  );
};
export default RozhanaHeader;
